import { fg } from '@atlaskit/platform-feature-flags';

export default {
	get(): boolean {
		return fg('is_jsm_dc_enabled_in_ui');
	},
};
